<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<form [formGroup]="form" (keydown.enter)="submitform($event)" (submit)="submitform($event)">

  <div class="mt-1 mt-md-3 mb-3">
    <app-step-indicator [(currentPage)]="currentPage" [indicators]="indicator"></app-step-indicator>
  </div>

  @switch (currentPage) {
    @case (1) {
      <app-user-coords-form [parentForm]="form" [formName]="pageFormName[currentPage]">
      </app-user-coords-form>
    }
    @case (2) {
      <app-user-profile-form [parentForm]="form" [formName]="pageFormName[currentPage]">
      </app-user-profile-form>
    }
    @case (3) {
      <app-user-products-list-form [parentForm]="form" [formName]="pageFormName[currentPage]" [products]="products">
      </app-user-products-list-form>
    }
    @case (4) {
      @if (currentPage === 4) {
        <app-user-infos-form [parentForm]="form" [formName]="pageFormName[currentPage]">
        </app-user-infos-form>
      }
    }
  }

  <div class="d-flex grid-gap-05rem">
    <button id="previous" type="button" [class.d-md-none]="currentPage === 1" class="btn btn-outline-primary"
      (click)="currentPage = currentPage - 1" [disabled]="currentPage === 1">
      <fa-icon class="me-2" icon="arrow-left" size="lg"></fa-icon>
      <span class="d-none d-md-inline-block">
        Précédent
      </span>
    </button>
    <app-cancel-button id="cancel" routerLink="/utilisateurs"></app-cancel-button>
    <span id="nextspan"
      [ngbTooltip]="form[this.pageFormName[currentPage]]?.invalid ? 'Il manque des champs obligatoires à renseigner' : ''">
      @if (currentPage !== 4) {
        <button id="next" type="submit" class="btn btn-primary" (click)="currentPage = currentPage + 1"
          [disabled]="form.get(this.pageFormName[currentPage])?.invalid">
          <span class="d-none d-md-inline-block">
            Suivant
          </span>
          <fa-icon class="ms-2" icon="arrow-right" size="lg"></fa-icon>
        </button>
      }
    </span>
    @if (currentPage === 4) {
      <button id="send" type="submit" class="btn btn-primary" (click)="submitform($event)" [disabled]="form?.invalid">
        <fa-icon class="d-none d-md-inline" icon="plus-circle"></fa-icon>
        Envoyer ma demande <span class="d-none d-md-inline">d'ajout</span>
      </button>
    }
  </div>
</form>
